import { RadioCard } from '@app/components/various/Fields/RadioCards';
import { RadioCardsField } from '@app/components/various/Form/FormField/RadioCardsField';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { GridViewProducts } from './GridViewProducts';
import { ListViewProducts } from './ListViewProducts';
interface Props {
  isDisabled: boolean;
  isLoading: boolean;
}

export const AllProductsLayoutFields = ({ isDisabled, isLoading }: Props) => {
  const { t } = useTranslation(['common', 'settings', 'linesheets']);
  const layouts = [
    {
      description: 'Let your users to customize number of columns with a grid view.',
      icon: GridViewProducts,
      label: t('common:grid_view'),
      value: 'grid',
    },
    {
      description: 'Show size matrices right on the products listing view.',
      icon: ListViewProducts,
      label: t('common:list_view'),
      value: 'list',
    },
  ];

  return (
    <section className="box space-y-5">
      <h3 className="heading-3">{t('settings:default_all_products_view')} </h3>
      <p className="text-neutral-40 body-2">{t('settings:default_all_products_view_description')}</p>
      <RadioCardsField
        helpMessage={t('settings:default_all_products_view_description')}
        name="allProductsViewLayout"
        className="flex flex-wrap gap-3"
        isLoading={isLoading}
        isDisabled={isDisabled}
      >
        {layouts.map(({ value, icon: LayoutIcon, label, description }) => (
          <RadioCard key={value} value={value} hasDescription className="flex-1 basis-64">
            {({ describedById, inputId }) => (
              <div className="flex flex-col items-center justify-center gap-y-3">
                <div>
                  <label
                    htmlFor={inputId}
                    className={cx('heading-3', isDisabled ? 'absolute-cursor-not-allowed' : 'absolute-cursor-pointer')}
                  >
                    {label}
                  </label>
                  <p id={describedById} className="body-2">
                    {description}
                  </p>
                </div>
                <LayoutIcon className="h-56 w-60" />
              </div>
            )}
          </RadioCard>
        ))}
      </RadioCardsField>
    </section>
  );
};
